import React from 'react';
import { CTAButton } from './CTAButton';
import { HERO_IMAGE, OFFER_ANCHOR } from '../data/product';
export function Hero() {
  return <section className="bg-navy px-4 py-4 sm:py-6" data-id="element-83" data-mp="eibqho5m10ai">
      <div className="mx-auto max-w-3xl" data-id="element-84" data-mp="9ka5uysjcswx">
        <h1 className="text-center text-[21px] leading-[1.05] text-white sm:text-4xl" data-id="element-85" data-mp="9lbg511q9bdl">
          THE COMPLETE VISUAL TROUBLESHOOTING SYSTEM FOR{' '}
          <span className="text-volt" data-id="element-86" data-mp="1297ahz3tqr77">INDUSTRIAL MAINTENANCE TECHNICIANS</span>
        </h1>
        <p className="mx-auto mt-1.5 max-w-2xl text-center text-[13px] font-semibold leading-snug text-white/90 sm:text-base" data-id="element-87" data-mp="xae74zi94gkr">
          Stop troubleshooting industrial equipment from scratch.
        </p>
        <p className="mx-auto mt-1 max-w-2xl text-center text-[13px] font-medium leading-snug text-white/80 sm:text-[15px]" data-id="element-88" data-mp="ncgkuhjyctus">
          Use ready-to-use diagnostic maps, inspection checklists and
          fault-isolation tools to identify problems with a clearer process.
        </p>
        <p className="mt-1.5 text-center font-head text-sm font-bold uppercase tracking-[0.12em] text-volt sm:text-base" data-id="element-89" data-mp="384s3cj4feb0f">
          Find the fault. Follow the checks. Diagnose with confidence.
        </p>

        <a href={OFFER_ANCHOR} className="mt-2 block" data-id="element-90" data-mp="39acwgl67hgrf">
          <img src={HERO_IMAGE} alt="INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO — complete 6-in-1 box set with 6 modules" className="mx-auto w-full max-w-md" data-id="element-91" data-mp="399tdr28qeocc" />
        </a>

        <CTAButton className="mx-auto mt-1 max-w-md" data-id="element-92" data-mp="30gq5r9guv3p3">
          🔧 YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>
        <p className="mt-1.5 text-center font-head text-sm font-bold uppercase tracking-wide text-white" data-id="element-93" data-mp="35aknw8gtbam2">
          GET INDUSTRIAL MAINTENANCE DIAGNOSTIC PRO™ TODAY
        </p>
        <p className="mt-0.5 text-center text-[11px] font-semibold text-white/80 sm:text-xs" data-id="element-94" data-mp="2vj7rr4nzdya8">
          🛡️ 7-Day Money-Back Guarantee{' '}
          <span className="text-volt" data-id="element-95" data-mp="2lkil681jc09a">🔧 COMPLETE 6-IN-1 SYSTEM</span>
        </p>
      </div>
    </section>;
}